<template>
    <form-select-group
        class="project-selector"
        :label="$tc('openApplications.selectProject')"
        v-model="internalValue"
        :options="projectsSelectOptions"
    >
        <template v-slot:default v-if="currentProject">
            <div class="project-selector__selected-project">
                <div class="project-selector__selected-project-data">
                    <div v-if="currentProjectLogo" class="project-selector__selected-project-logo">
                        <img class="project-selector__selected-project-logo-image" :src="currentProjectLogo" />
                    </div>
                    <div class="project-selector__selected-project-metadata">
                        <div>
                            {{ currentProjectDisplayText }}
                        </div>
                    </div>
                </div>
                <div v-html="$tc('icons.carret-down')"></div>
            </div>
        </template>
        <template v-for="(project, index) in projects" v-slot:[`option-${index}`]>
            <div :key="index">
                <div class="project-selector__project-option-data" v-if="project">
                    <div v-if="getProjectLogo(project)" class="project-selector__project-option-logo">
                        <img class="project-selector__project-option-logo-image" :src="getProjectLogo(project)" />
                    </div>
                    <div class="project-selector__project-option-metadata">
                        <div>
                            {{ getProjectDisplayText(project) }}
                        </div>
                    </div>
                </div>
                <div v-else>{{ $tc("words.all") }}</div>
            </div>
        </template>
    </form-select-group>
</template>

<script>
import {FormSelectGroup, mixins, store} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");
const {Proxyable} = mixins;

export default {
    name: "project-selector",
    components: {
        FormSelectGroup,
    },
    mixins: [Proxyable],
    props: {projects: {type: Array}},
    computed: {
        ...mapState(["openApplicationsSelectedProjectId"]),
        projectsSelectOptions() {
            let projectsList = this.projects.map(element => ({
                text: element ? element.viewName : this.$tc("words.all"),
                value: element?.id,
            }));
            return projectsList;
        },
        currentProject() {
            return this.projects.find(element => element?.id === this.internalValue);
        },
        currentProjectLogo() {
            return this.getProjectLogo(this.currentProject);
        },
        currentProjectDisplayText() {
            return this.getProjectDisplayText(this.currentProject);
        },
    },
    watch: {
        openApplicationsSelectedProjectId: {
            handler(newValue) {
                if (typeof newValue !== "undefined") {
                    this.internalValue = newValue;
                }
            },
            immediate: true,
        },
        internalValue: {
            handler(newValue) {
                this.selectProject({projectId: newValue});
            },
        },
    },
    methods: {
        ...mapActions({
            selectProject: "SELECT_PROJECT",
        }),
        getProjectLogo(project) {
            return project?.logo?.src || project?.viewLogoUrl;
        },
        getProjectDisplayText(project) {
            return this.$tc("openApplications.selectProjectOption", project.country ? 1 : 0, {
                name: project.viewName,
                country: project.country,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.project-selector::v-deep {
    .project-selector__selected-project {
        @apply flex w-full items-center justify-between;
    }

    .project-selector__selected-project-data,
    .project-selector__project-option-data {
        @apply flex items-center;
    }

    .project-selector__selected-project-logo,
    .project-selector__project-option-logo {
        @apply mr-2;
    }

    .project-selector__selected-project-logo-image,
    .project-selector__project-option-logo-image {
        @apply block rounded;
        width: $project-logo-width;
        height: $project-logo-height;
    }

    .project-selector__selected-project-metadata,
    .project-selector__project-option-metadata {
        @apply flex flex-col items-start justify-center;
    }
}
</style>
